import styled from 'styled-components';
import { Field } from 'formik';
import DonationInput from '../form-elements/donation-input';
import { breakpoint } from '../theme/breakpoint';
import {
  OwnAmountSubmit,
  InputBox,
} from '../donation-hero-with-buttons/styles';

export const Hero = styled.section`
  position: relative;
  overflow: hidden;
  margin-bottom: ${({ theme }) => theme.spacing.large};

  ${breakpoint.desktop`
    height: 450px;
  `}
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: stretch;
  flex: 1;
`;

export const StyledField = styled(Field)`
  flex-grow: 1;
`;

export const StyledDonationInput = styled(DonationInput)``;

export const StyledOwnAmountSubmit = styled(OwnAmountSubmit)``;

export const StyledInputBox = styled(InputBox)`
  padding: ${({ theme }) => theme.spacing.standard};
`;
